<template>
  <div>
    <contactWeb v-if="!isMobile"></contactWeb>
    <contactMobile v-if="isMobile"></contactMobile>
  </div>
</template>
<script>
import contactWeb from './Contact-web.vue'
import contactMobile from './Contact-mobile.vue'
export default {
  name: 'contact',
  data() {
    return {
      isMobile: true
    }
  },
  components: {
    contactWeb,
    contactMobile
  },
  mounted() {
    const detectDeviceType = () =>
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? 'Mobile'
        : 'Desktop'
    this.isMobile = detectDeviceType() === 'Mobile'
  },
  methods: {}
}
</script>
<style lang="less">
</style>
